import cn from 'clsx'
import { Box } from '@/components/Box/Box'

import css from './screen-readers-only.module.css'

import type { BoxProps } from '@/components/Box/Box'

type ScreenReadersOnlyProps = BoxProps & {
    children: React.ReactNode
}

function ScreenReadersOnly({ children, ...rest }: ScreenReadersOnlyProps) {
    return (
        <Box className={cn(css.screenReaderOnly)} {...rest}>
            {children}
        </Box>
    )
}

export { ScreenReadersOnly }
export type { ScreenReadersOnlyProps }
